/**
 * D1 — Menue an der aktuellen Position.
 *
 * header.liquid setzt nur Klassen: `details.d1-here` auf dem Pfad,
 * `.d1-here__leaf` auf der aktuellen Kategorie. Das Aufklappen passiert hier,
 * und zwar erst beim Oeffnen der Schublade — ein `open` im HTML wuerde am
 * Desktop das Megamenue schon beim Laden aufreissen, und MainMenu.init() in
 * main.js schliesst beim Laden ohnehin alle Unterebenen wieder.
 *
 * Mobil ist das Menue kein Akkordeon: Ebene 1 schiebt ein bildschirmfuellendes
 * Panel (.main-nav__child, position:fixed, transform translateX) von rechts
 * herein, Ebene 2 klappt darin auf. Ebene 1 wird deshalb NICHT per .open
 * gesetzt, sondern mit einem Klick auf die summary — der laeuft durch
 * MainMenu.handleNavClick und setzt is-open, Overlay und Fokusfalle genau wie
 * ein echter Fingertipp. Ebene 2 ist ein natives <details> ohne eigene Logik;
 * dort genuegt .open.
 *
 * Am Desktop tut dieser Baustein nichts — dort reichen die Klassen aus Liquid.
 */
(() => {
  const MD = '(min-width: 769px)'; // theme.mediaQueries.md aus layout/theme.liquid

  const menu = document.querySelector('main-menu[data-d1-here="1"]');
  if (!menu) return;

  const schublade = menu.querySelector('.main-menu__disclosure');
  if (!schublade) return;

  const nurEbene1 = menu.dataset.d1HereDepth === 'l1';
  const scrollen = menu.dataset.d1HereScroll === '1';
  let laeuft = false;
  // Nur beim ersten Oeffnen je Seitenaufruf. Wer im Menue bewusst woandershin
  // blaettert, es schliesst und wieder oeffnet, soll dort bleiben.
  let schonGeschehen = false;

  /**
   * Naechster scrollbarer Vorfahre. Mobil ist das je nach Tiefe
   * .main-nav__child (das Kategoriepanel) oder .main-menu__content.
   * @param {Element} el - Startelement.
   * @returns {?Element} Der Behaelter oder null.
   */
  const behaelter = (el) => {
    let p = el.parentElement;
    while (p && p !== document.body) {
      const oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 4) return p;
      p = p.parentElement;
    }
    return null;
  };

  /**
   * Schiebt die aktuelle Stelle in die Mitte ihres Behaelters.
   * Bewusst ueber scrollTop statt scrollIntoView: letzteres zieht die ganze
   * Seite mit, obwohl nur das Panel scrollen soll.
   */
  const hinScrollen = () => {
    if (!scrollen) return;
    const ziel = menu.querySelector('.d1-here__leaf') || menu.querySelector('details.d1-here');
    if (!ziel) return;
    const box = behaelter(ziel);
    if (!box) return;
    const oben = ziel.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop;
    box.scrollTop = Math.max(0, oben - (box.clientHeight / 2) + (ziel.offsetHeight / 2));
  };

  const aufklappen = () => {
    if (laeuft || schonGeschehen || window.matchMedia(MD).matches) return;

    const ebene1 = menu.querySelector('.main-nav > li > details.d1-here');
    if (!ebene1) return;
    laeuft = true;
    schonGeschehen = true;

    const knopf = ebene1.querySelector(':scope > summary.js-toggle');
    if (knopf && !ebene1.classList.contains('is-open')) knopf.click();

    if (!nurEbene1) {
      ebene1.querySelectorAll('details.d1-here').forEach((d) => { d.open = true; });
    }

    // Zwei Anlaeufe: beim ersten steht das Panel noch auf translateX(100%) und
    // hat keine nutzbare Scrollhoehe. Die Transition dauert 0.2s (main.css).
    requestAnimationFrame(hinScrollen);
    setTimeout(hinScrollen, 260);
    setTimeout(() => { laeuft = false; }, 400);
  };

  schublade.addEventListener('toggle', () => {
    if (schublade.open) aufklappen();
  });
})();
